export const badgePresets = (tokens) => {
    const { badge } = tokens.component;
    return {
        size: {
            sm: {
                sx: {
                    ".MuiBadge-badge": {
                        fontSize: badge.small.fontSize.value,
                        height: badge.small.height.value,
                        minWidth: badge.small.width.value,
                        paddingLeft: badge.small.paddingHorizontal.value,
                        paddingRight: badge.small.paddingHorizontal.value,
                        "&.MuiBadge-counter, &.MuiBadge-inlineCounter": {
                            paddingLeft: badge.counter.paddingHorizontal.value,
                            paddingRight: badge.counter.paddingHorizontal.value,
                        },
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=badge.js.map